import 'css-chunk:../../src/components/form/label/index.module.scss';export default {
  "label": "_label_1v93v_1"
};